import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import MasterComponent from '../../../../../components/Forms';
import ShortListedConfig from '../../../../../entity/HRM/pre-onboarding/shortlistedConfig';
import { Button, Col, Dropdown, Flex, message, Modal, Rate, Row, Space, Tag, Typography } from 'antd';
import { ActionConfig, ColumnConfig, MasterConfigs } from '../../../../../interfaces/entity';
import NextRoundModal from '../Screening/modal';
import { DownOutlined, EyeOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux';
import { putData } from '../../../../../actions/developer';
import CandidateResponse from '../candidates/candidateResponse';
import { constants } from '../../../../../constants/common';
import FormSetup from '../../../../../components/Forms/FormSetup';

const TestComponent = () => {
  const level = constants.PROFILE_STATUS.TEST;
  const [nextRound, setNextRound] = useState(false)
  const [candidateType, setCandidateType] = useState(null)
  const [selected, setSelectedRow] = useState([])
  const [selectedURL, setSelectedURL] = useState(null)
  const [sendTestLink, setSendTestLink] = useState(false)
  const [selectedCandidate, setSelectedCandidate] = useState(null)
  const dispatch = useDispatch();

  const filter = (): ActionConfig => {
    return {
      actionType: 'filter',
      name: 'Filter'
    }
  }

  const onEdit = async (text, item, type = 'currentCTC') => {
    console.log("text, item,text, item,", text, item)
    let payload;
    if (type == 'currentCTC' && text != item?.currentCTC) {
      payload = { ...payload, currentCTC: text }
    }
    if (type == 'expectedCTC' && text != item?.expectedCTC) {
      payload = { ...payload, expectedCTC: text }
    }

    if (type == 'experiance' && text != item?.experiance) {
      payload = { ...payload, experiance: text }
    }

    if (type == 'noticePeriod' && text != item?.noticePeriod) {
      payload = { ...payload, noticePeriod: text }
    }

    if ((text != item?.currentCTC && type == 'currentCTC') || (text != item?.expectedCTC && type == 'expectedCTC')
      || (text != item?.expectedCTC && type == 'expectedCTC')
      || (text != item?.experiance && type == 'experiance')
      || (text != item?.noticePeriod && type == 'noticePeriod')) {
      const resData = await dispatch(putData(ShortListedConfig.api() + '/' + level + '/' + item?._id, payload));
      if (resData) {
        onRefresh()
      }
    }
  }

  const linkSendConfig: MasterConfigs = {
    api: () => '/test-setup',
    modalTitle: () => 'Send Test Link',
    apiParams: {
      candidate: selectedCandidate,
    },
    getFormColumns: () => [
      {
        name: 'testConfig',
        label: 'Test',
        type: 'select',
        rules: [{ required: true, message: 'Please select Test' }],
        isCombo: true,
      },
      {
        span: 16
      },
      {
        name: "linkExpiredAfter",
        label: "Link Expired After",
        type: "select",
        children: Array.from({ length: 24 }, (_, i) => {
          return { name: i + 1, value: i + 1 }
        })
      },
      {
        name: "expiredType",
        label: "Link Expired Type",
        type: "select",
        children: [
          { name: 'hours', value: 'hours' },
          { name: 'days', value: 'days' }
        ]
      }
    ],
    combo: [
      {
        api: '/online-test-settings',
        idKey: '_id',
        name: 'testConfig',
        render: (text) => text?.name
      }
    ],
    onRefresh: () => {
      dispatch({
        type: 'REFRESH_TABLE',
        refreshTable: true
      })
    }
  }

  const OverriddenConfig: MasterConfigs = {
    ...ShortListedConfig,
    api: () => ShortListedConfig.api() + '/' + level,
    tableProps: {
      rowSelection: {
        ...ShortListedConfig.rowSelection,
        onChange: (selectedRowKeys, selectedRows) => {
          setSelectedRow(selectedRows)
        },
      },
    },
    loadPagination: true,
    actions: [filter(), ...ShortListedConfig.actions, selected.length > 0 && { name: 'move to next', actionType: 'Add', onClick: () => onMoveToNext() }],
    getColumns: () => [
      ...ShortListedConfig.getColumns().filter(ele => ele.key !== 'addedBy').map((ele: any) => {
        let edit = {};
        if (['currentCTC', 'expectedCTC', 'experiance'].includes(ele?.dataIndex)) {
          edit = {
            dataIndex: '',
            key: '',
            render: (text) => {
              return <Typography.Title level={5} editable={{
                onChange: (e) => onEdit(e, text, ele?.dataIndex),
              }}>{text?.[ele?.dataIndex]}</Typography.Title>
            }
          }
        }
        return {
          ...ele,
          ...edit
        }
      }) as ColumnConfig[],
      {
        title: 'Notice Period',
        dataIndex: '',
        key: '',
        align: 'center',
        width: 120,
        render: (text) => {
          return <Typography.Title level={5} editable={{
            onChange: (e) => onEdit(e, text, 'noticePeriod'),
          }}>{text?.noticePeriod}</Typography.Title>
        }
      },
      {
        title: 'Resume',
        dataIndex: '',
        key: '',
        width: 90,
        align: 'center',
        render: (text) => {
          return <Button type='link' icon={<EyeOutlined />} onClick={() => onViewModal(text)} />
        },
      },
      {
        title: 'Level',
        dataIndex: 'candidateType',
        key: 'candidateType',
        width: 100,
        align: 'center',
      },
      {
        title: 'Test Link',
        dataIndex: '',
        key: '',
        width: 100,
        align: 'center',
        fixed: 'right',
        render: (text) => {
          return <Button type='link' onClick={() => {
            setSendTestLink(true)
            setSelectedCandidate(text?._id)
          }} >Send</Button>
        }
      },
    ].filter(Boolean) as ColumnConfig[],
    getFormColumns: () => [
      ...ShortListedConfig.getFormColumns().map(ele => {
        if (ele.name == 'candidateType') {
          return {
            ...ele,
            selectProps: {
              onChange: (text) => {
                setCandidateType(text);
              }
            }
          }
        } else {
          if (ele.name == "experiance") {
            if (candidateType == 'Experience') {
              return ele
            } else {
              return
            }
          } else {
            return ele
          }
        }
      }
      ).filter(Boolean),
    ]
  };



  const onRefresh = () => {
    dispatch({
      type: 'REFRESH_TABLE',
      refreshTable: true
    })
  }

  const onViewModal = (item) => {
    const url = `${process.env.FILE_URL}${item?.resume}`
    setSelectedURL({ ...item, name: item?.firstName, url, skills: item?.skills });
  }

  const onMoveToNext = () => {
    setNextRound(true)
  }

  return <React.Fragment>
    <CandidateResponse selectedURL={selectedURL} setSelectedURL={setSelectedURL} />
    <NextRoundModal isVisible={nextRound} onClose={() => setNextRound(false)} selected={selected} level={level} />
    <FormSetup open={sendTestLink} onClose={() => setSendTestLink(false)} config={linkSendConfig} isModal={true} />
    <MasterComponent config={OverriddenConfig} />
  </React.Fragment>
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(TestComponent);
